<template>
    <UpdateProfileForm/>

    <!-- Natif uniquement : le pied de page légal du site n'est plus rendu dans
         l'app, or les liens CGU / mentions légales / confidentialité doivent
         rester joignables (Google Play exige un accès à la politique de
         confidentialité depuis l'application). On les republie ici, en
         RouterLink : un <a href> vers ouicsport.fr ouvrirait le navigateur
         système et ferait sortir de l'app. -->
    <section v-if="isNative" class="oc-account-legal" aria-labelledby="oc-account-legal-title">
      <h2 id="oc-account-legal-title" class="oc-account-legal__title">Informations</h2>

      <nav class="oc-account-legal__list">
        <RouterLink class="oc-account-legal__link" to="/CGU">CGU / CGV</RouterLink>
        <RouterLink class="oc-account-legal__link" to="/mentions-legales">Mentions légales</RouterLink>
        <RouterLink class="oc-account-legal__link" to="/politique-de-confidentialite">Politique de confidentialité</RouterLink>
        <RouterLink class="oc-account-legal__link" to="/contact">Nous contacter</RouterLink>
      </nav>

      <p class="oc-account-legal__id">OuiCSport — SIREN 852096536 — Atout France IM095220001</p>
    </section>
</template>

<script>
import { ref } from 'vue';
import { useStore } from 'vuex';
import UpdateProfileForm from '../components/UpdateProfileForm.vue';
import { isNative } from '@/api/base';
export default {
  setup() {
    const store = useStore();
    const userId = ref(store.state.auth.user.data.id);
    const creditsBalance = ref(0);
    const userDetails = ref(null);


    const fetchCreditsBalance = async () => {
      const balance = await store.dispatch('user/fetchCreditsBalance', {
        userId: userId.value
      });
      creditsBalance.value = balance;
    };

    fetchCreditsBalance();

    return { creditsBalance, userDetails, isNative };
  },
  components: {
      UpdateProfileForm
    }
}

</script>

<style>
/* =========================================================================
   Écran Compte — bloc « Informations » (natif uniquement)
   -------------------------------------------------------------------------
   Le fond de page et les marges de sécurité sont désormais posés une seule
   fois par src/styles/mobile-app.css (body.is-native + .page-main) : les
   redéfinir ici donnait deux gris de fond différents selon l'écran.
   Ce bloc ne style plus que la rubrique légale ajoutée ci-dessus.
   ========================================================================= */

body.is-native .oc-account-legal {
  padding: 0 var(--oc-sp-4) var(--oc-sp-8);
  background: var(--oc-bg);
}

body.is-native .oc-account-legal__title {
  margin: 0 0 var(--oc-sp-3);
  font-family: var(--oc-font-display);
  font-size: var(--oc-text-lg);
  font-weight: 400;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: var(--oc-ink);
}

/* Rubrique en carte : mêmes surfaces que le reste de l'écran Compte. */
body.is-native .oc-account-legal__list {
  display: flex;
  flex-direction: column;
  background: var(--oc-surface);
  border-radius: var(--oc-r-lg);
  box-shadow: var(--oc-e1);
  overflow: hidden;
}

body.is-native .oc-account-legal__link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--oc-sp-3);
  min-height: var(--oc-tap);
  padding: var(--oc-sp-3) var(--oc-sp-4);
  font-family: var(--oc-font-text);
  font-size: var(--oc-text-base);
  font-weight: 600;
  color: var(--oc-ink);
  text-decoration: none;
  border-top: 1px solid var(--oc-line);
  transition: background var(--oc-fast) var(--oc-ease);
}

body.is-native .oc-account-legal__link:first-child {
  border-top: 0;
}

body.is-native .oc-account-legal__link:active {
  background: var(--oc-surface-2);
}

/* Chevron : signale une navigation interne, pas une sortie vers le navigateur. */
body.is-native .oc-account-legal__link::after {
  content: '';
  flex: 0 0 auto;
  width: 7px;
  height: 7px;
  border-right: 2px solid var(--oc-ink-3);
  border-bottom: 2px solid var(--oc-ink-3);
  transform: rotate(-45deg);
}

body.is-native .oc-account-legal__id {
  margin: var(--oc-sp-4) 0 0;
  font-size: var(--oc-text-xs);
  line-height: 1.5;
  color: var(--oc-ink-3);
  text-align: center;
}
</style>

